"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPathValueConfig = exports.mergeRecursiveValueConfig = void 0;
const flatArray_1 = require("../../utils/flatArray");
const object_1 = require("../../utils/object");
/** Override properties. Specified config last argument */
const mergeValueConfig = (array) => {
    const configs = (0, flatArray_1.flatArray)(array);
    const result = configs === null || configs === void 0 ? void 0 : configs.reduce((acc, x) => ({
        ...(0, object_1.mergeObjects)(acc, x, (_, v1, v2) => v2 !== null && v2 !== void 0 ? v2 : v1),
        shape: (0, object_1.mergeObjects)(acc === null || acc === void 0 ? void 0 : acc.shape, x === null || x === void 0 ? void 0 : x.shape, (_, v1, v2) => mergeValueConfig([v1, v2])),
    }), undefined);
    return result;
};
/** Override properties. Specified config last argument */
const mergeRecursiveValueConfig = (config, value) => {
    var _a;
    const configs = (_a = (0, flatArray_1.flatArray)(config)) === null || _a === void 0 ? void 0 : _a.map(x => x(value));
    return mergeValueConfig(configs);
};
exports.mergeRecursiveValueConfig = mergeRecursiveValueConfig;
const getPathValueConfig = (config, path) => {
    const simplePath = path;
    const result = simplePath.reduce((acc, key) => {
        var _a;
        const shapeKey = (acc === null || acc === void 0 ? void 0 : acc.type) === 'array' ? 'item' : key;
        return (_a = acc === null || acc === void 0 ? void 0 : acc.shape) === null || _a === void 0 ? void 0 : _a[shapeKey];
    }, config);
    return result;
};
exports.getPathValueConfig = getPathValueConfig;
//# sourceMappingURL=valueConfig.js.map